var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.disabled
    ? _c("div", { staticClass: "pb-0 group-title-wrapper" }, [
        _c("div", { staticClass: "type-label" }, [_vm._v("Campaign")]),
        _vm._v(" "),
        _c("div", { staticClass: "group-title" }, [
          _c(
            "h1",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editTitle,
                  expression: "!editTitle"
                }
              ],
              staticClass:
                "mb-0 exclude-outside-click edit-d-title project-title",
              on: { click: _vm.activateTitleField }
            },
            [_vm._v(_vm._s(_vm.socialCampaignDetail.title))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.editTitle,
                expression: "editTitle"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.socialCampaignDetail.title,
                expression: "socialCampaignDetail.title"
              },
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.clickOutsideTitle,
                expression: "clickOutsideTitle"
              }
            ],
            ref: "editTitleRef",
            staticClass:
              "form-control mb-3 title-field exclude-outside-click h1",
            attrs: { type: "text", placeholder: "Social Media Campaign..." },
            domProps: { value: _vm.socialCampaignDetail.title },
            on: {
              change: function($event) {
                return _vm.updateSocialCampaign()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.socialCampaignDetail, "title", $event.target.value)
              }
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }